/**=========================================================
 * Module: counter.js
 * Counter Controller
 =========================================================*/

App.controller('CounterController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";
     
    $scope.type = 'counter';
    
    $scope.model = {};
    $scope.error = {};
      
    D.load($scope.type, $scope.cid).then(
                function(model){
                    $scope.model = model;
                }      
            ).catch(function(error){
                $scope.error = error;
            });
      
      
  }
  ]);